import { render, staticRenderFns } from "./payment-gateway-balance-modal.vue?vue&type=template&id=deaf0f4e&"
import script from "./payment-gateway-balance-modal.vue?vue&type=script&lang=js&"
export * from "./payment-gateway-balance-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports